import React, { PureComponent } from 'react';
import Select from 'react-select';
import { t } from '@lingui/macro';

class SelectStation extends PureComponent {
    constructor(props) {
        super(props);
        const options = [{ value: 'all', label: t({ id: 'od.allstation' }) }];
        for (const key in props.stationlist) {
            if (this.props.stationlist[key]) {
                const station = props.stationlist[key];
                const n = props.geo[station];
                options.push({ value: station, label: n.station });
            }
        }
        this.state = {
            options,
        };
    }

    handleChange = (select) => {
        if (select && select.value) this.props.onChange(select.value);
    }

    render() {
        const { value } = this.props;
        const { options } = this.state;
        const selectedValue = options.filter((item) => {
            if (item.value === value) {
                return true;
            }
            return false;
        })[0];

        return (
            <Select
                value={selectedValue}
                onChange={this.handleChange}
                styles={{
                    option: (styles, { isSelected }) => ({
                        ...styles,
                        color: isSelected ? 'white' : 'black',
                    }),
                }}
                options={options}
                clearable={false}
            />
        );
    }
}

export default (SelectStation);
